export const BLOCK_TYPES = [
    { id: 'block_entry', name: 'Entry' },
    { id: 'block_autogiro', name: 'Sign direct debit' },
    { id: 'block_grouptraining', name: 'Group workout' },
    { id: 'block_course', name: 'Course booking' },
    { id: 'block_resourcebooking', name: 'Resource booking' },
    { id: 'block_teamsport', name: 'Competition' },
];
